import Stripe from 'stripe'

export enum TransactionStatus {
    PENDING = 'pending',
    IN_PROGRESS = 'in-progress',
    ERROR = 'error',
    DONE = 'done',
}

export interface Transaction {
    transaction_id: string
    payment_intent_id: string
    products: (Stripe.Product & { quantity: number; amount: number })[]
    status: TransactionStatus
    message: string | null
    date_created: Date
    date_updated: Date
}
